var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"mb-4"},[_c('h1',{staticClass:"display-1 font-weight-bold mx-1 mb-3"},[_vm._v("Public Page")]),_c('p',[_vm._v("Update stuff that appears on your public page, both for artists and retailers")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }